import { render, staticRenderFns } from "./courseGoodsDetail.vue?vue&type=template&id=28d9d11c&scoped=true"
import script from "./courseGoodsDetail.vue?vue&type=script&lang=js"
export * from "./courseGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./courseGoodsDetail.vue?vue&type=style&index=0&id=28d9d11c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9d11c",
  null
  
)

export default component.exports